import { WEB_CONSEST_LINK, WEB_OFFER_LINK_SC_NEW, WEB_POLICY_LINK } from '@/shared/lib/utils/constants/pdfDocs'

import cls from './AgreementBlock.module.scss'

/**
 * Block with agreement text
 */
export const AgreementBlock = (): JSX.Element => (
	<div className={cls.agreementBlock}>
		<span>
			Нажимая кнопку, я подтверждаю свое ознакомление и согласие с &nbsp;
			<a
				href={WEB_OFFER_LINK_SC_NEW}
				target="_blank"
				title="Ознакомиться с согласием на обработку персональных данных (pdf)">
				Офертой
			</a>
			,{' '}
			<a href={WEB_POLICY_LINK} target="_blank" title="Ознакомиться с согласием на обработку персональных данных (pdf)">
				Политикой Конфиденциальности
			</a>
			&nbsp;и&nbsp;
			<a
				href={WEB_CONSEST_LINK}
				target="_blank"
				title="Ознакомиться с согласием на обработку персональных данных (pdf)">
				Согласием на обработку персональных данных
			</a>
			. &nbsp; Я достиг(ла) 18-летнего возраста.
		</span>
	</div>
)
